<template>
  <main id="sign-page" class="">
    <header class="sign-header row">
      <h2 class="title col-11">
        <i class="fa-regular fa-heart me-0"></i>lich Willkommen
      </h2>
      <router-link
        class="btn text-primary col me-auto"
        :to="{ name: 'LandingPage' }"
        custom
        v-slot="{ navigate }"
      >
        <span
          role="link"
          @click="navigate"
          @keypress.enter="navigate"
        >
          <i class="fa-solid fa-xmark"></i>
        </span>
      </router-link>
    </header>
    <!-- SIGN UP -->
    <mainSignUp v-if="$route.name == 'Signup'" class="signup" />

    <!--ForgotPassword-->
    <mainForgotPassword
      v-else-if="$route.name == 'ForgotPassword'"
      class="ForgotPassword"
    />

    <!-- ResetPassword -->
    <mainResetPassword
      v-else-if="
        $route.name == 'ResetPassword' && $route.params.token.length > 5
      "
      class="resetpassword"
    />

    <!-- ConfirmationEmail -->
    <mainConfirmationEmail
      v-else-if="
        $route.name == 'ConfirmationEmail' && $route.params.token.length > 5
      "
      class="resetpassword"
    />

    <!-- signin -->
    <mainSignIn v-else class="signin" />
  </main>
</template>

<script>
import mainSignIn from "./components/SignIn.vue";
import mainSignUp from "./components/SignUp.vue";
import mainResetPassword from "./components/ResetPassword.vue";
import mainForgotPassword from "./components/ForgotPassword.vue";
import mainConfirmationEmail from "./components/ConfirmationEmail.vue";

export default {
  name: "Sign",
  metaInfo() {
    return {
      title: "Sign",
      titleTemplate: "%s | Mobile Tech Zone",
    };
  },

  components: {
    mainSignIn,
    mainSignUp,
    mainResetPassword,
    mainForgotPassword,
    mainConfirmationEmail,
  },

  data() {
    return {};
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$store.state.modules.account.user && !this.$route.params.token) {
        const account = JSON.parse(localStorage.account);
        if (account.status != "blocked") {
          this.$router.push({ name: "CPanel" });
        } else {
          this.$router.push({ name: "LandingPage" });
        }
      } else {
        this.$store.state.utils.loaded = true;
      }
    });
  },

  methods: {},
};
</script>

<style>
.has_required {
  /* text-decoration: line-through; */
  color: #689868;
}

#sign-page {
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  width: 100%;
  min-width: 300px;
  max-width: 600px;
  margin: 0 auto;
  min-height: 100vh;
  background-color: rgba(253, 253, 250);
  padding: 10px 20px;
}

.exit-button {
  position: absolute;
  top: 10px;
  right: 10px;
}

#sign-page .sign-header {
  text-align: center;
  margin: 20px 0;
}
</style>
